export default __webpack_public_path__ + "static/media/tinnova.c2ce63ea.gif";